/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.end-of-year.promote-students'},
});

const PromoteStudentsItem = () => (
  <RouteLinkItem
    route="midas/settings/end-of-year/promote-students"
    title={messages.title}
  />
);

export default PromoteStudentsItem;
